import { flushSync } from 'react-dom';

export const deferExecution = (fn, delay = 0) => {
  return setTimeout(() => {
    flushSync(() => {
      fn();
    });
  }, delay);
};
